// =====================================================================
// Assessment Center — Instructor Panel
// Route definitions, mounted in src/App.tsx. Every route here is
// gated by RequireRole — an unauthenticated visitor, or a signed-in
// student, is redirected before InstructorLayout ever renders.
// =====================================================================
import { Route } from "react-router-dom";
import { RequireRole } from "../../shared/auth/RequireRole";
import InstructorLayout from "./components/InstructorLayout";
import DashboardPage from "./pages/DashboardPage";
import ExamsPage from "./pages/ExamsPage";
import QuestionBankPage from "./pages/QuestionBankPage";
import CreateQuestionPage from "./pages/CreateQuestionPage";
import CreateExamPage from "./pages/CreateExamPage";
import GradingPage from "./pages/GradingPage";
import GradingReviewPage from "./pages/GradingReviewPage";

export const instructorAssessmentCenterRoutes = (
  <Route
    path="/instructor/assessment-center"
    element={
      <RequireRole role="instructor">
        <InstructorLayout />
      </RequireRole>
    }
  >
    <Route index element={<DashboardPage />} />
    <Route path="exams" element={<ExamsPage />} />
    <Route path="exams/new" element={<CreateExamPage />} />
    <Route path="exams/:id/edit" element={<CreateExamPage />} />
    <Route path="question-bank" element={<QuestionBankPage />} />
    <Route path="questions/new" element={<CreateQuestionPage />} />
    <Route path="questions/:id/edit" element={<CreateQuestionPage />} />
    <Route path="grading" element={<GradingPage />} />
    <Route path="grading/:attemptId" element={<GradingReviewPage />} />
  </Route>
);
